export default __webpack_public_path__ + "static/media/ic_link_40.7a5ea5ed.svg";